module.exports = __webpack_public_path__ + "static/Avatar-d160c426d6b9065835884aa96a9f921d.png";